<div class="table-container">
    <table mat-table [dataSource]="source()" multiTemplateDataRows class="mat-elevation-z0">
        @for (column of columnsConfig; track column) {
        <ng-container [matColumnDef]="column.columnDef">
            <th mat-header-cell *matHeaderCellDef>
                {{ column.header }}
            </th>
            <td mat-cell *matCellDef="let row"
                [class]="{ grouped: column.columnDef === 'indicator' && this.selectedGroupValue() }">
                @if (!customColumns.includes(column.columnDef)) {
                <div class="clamped" [matTooltip]="column.cell(row)">
                    {{ column.cell(row) }}
                </div>
                } @else {
                <ng-container
                    *ngTemplateOutlet="customTpl[column.columnDef]; context: { $implicit: row, column: column }">
                </ng-container>
                }
            </td>
        </ng-container>
        }

        <!-- Expanded Content section - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let row" [class.expanded]="checkExpanded(row)"
                [attr.colspan]="columnsConfig.length">
                <div class="example-element-detail" [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'">
                    <div class="info-block-wrapper">
                        <div class="header">
                            <h4>Detailed Information</h4>
                        </div>
                        <div class="grid-row">
                            @for (item of detailedInfoContent; track $index) {
                            <div class="info-block-item">
                                <div class="icon-wrapper">
                                    <mat-icon> {{ item.icon }}</mat-icon>
                                </div>
                                <div class="content-wrapper">
                                    <div class="subtitle-2">{{ item.title }}</div>
                                    @if (!['location', 'rule', 'schematron'].includes(item.key)) {
                                    <span [class.not-available-text]="!row[item.key]">{{ row[item.key] || "Not available" }}</span>
                                    } @else {
                                    <ng-container
                                        *ngTemplateOutlet="customTpl[item.key]; context: { $implicit: row, item }">
                                    </ng-container>
                                    }
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </td>
        </ng-container>

        <!-- Group Column -->
        <ng-container matColumnDef="group">
            <td mat-cell *matCellDef="let row" [attr.colspan]="columnsConfig.length">
                <div class="group-row-header-container">
                    <ng-container *ngTemplateOutlet="groupedToggle; context: { $implicit: row }"> </ng-container>
                    <strong>Group: {{ row.group }} ({{ row.items.length }})</strong>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>

        <!-- Grouped Row -->
        <tr class="group-row" mat-row *matRowDef="let row; columns: ['group']; when: isGroupRow"
            (click)="groupExpanded.toggle(row.id)"></tr>

        <!-- Data row -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns; when: isNotGroup" class="element-row"
            [class.expanded-row]="rowExpanded.isSelected(row)"
            [style]="{'display': !groupExpanded.isSelected(row.id) && !!selectedGroupValue() ? 'none' : null }"
            (click)="rowExpanded.toggle(row)" [@fadeInOut]>
        </tr>

        <!-- Expanded detail row -->
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']; when: isNotGroup" class="example-detail-row"></tr>

        <!-- No data row -->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell no-data-cell" [attr.colspan]="columnsConfig.length">
                <div class="no-data-wrapper">
                    @if (!source().data.length) {
                    <mat-icon>info</mat-icon>
                    <span>No data yet</span>
                    } @else {
                    <mat-icon>search_off</mat-icon>
                    <span>No data matching the filter</span>
                }
                </div>
            </td>
        </tr>
    </table>
</div>

<mat-paginator #paginator (page)="onPageChange($event)" [pageSize]="50" [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons>
</mat-paginator>

<!-- Custom table column content -->
<ng-template #indicator let-row>
    <button mat-icon-button aria-label="expand row" (click)="rowExpanded.toggle(row); $event.stopPropagation()">
        @if (rowExpanded.isSelected(row)) {
        <mat-icon>keyboard_arrow_up</mat-icon>
        } @else {
        <mat-icon>keyboard_arrow_down</mat-icon>
        }
    </button>
</ng-template>

<ng-template #groupedToggle let-row>
    <button mat-icon-button aria-label="expand row" (click)="setExpandedgroup(row); $event.stopPropagation()">
        @if (groupExpanded.isSelected(row.id)) {
        <mat-icon>keyboard_arrow_down</mat-icon>
        } @else {
        <mat-icon>keyboard_arrow_right</mat-icon>
        }
    </button>
</ng-template>

<ng-template #ruleId let-row let-column="column">
    @if (row.ruleId) {
    <div [matTooltip]="row.ruleId" #ruleIdContainer class="rule-id-container">
        <span>{{ column.cell(row) }}</span>
    </div>
    }
</ng-template>

<ng-template #severity let-row let-column="column">
    <div class="severity-badge" [class]="row?.flag?.toLowerCase()">
        <mat-icon [color]="severityMap[row?.flag?.toLowerCase()]?.color">
            {{ severityMap[row?.flag?.toLowerCase()]?.icon }}
        </mat-icon>
        {{ column.cell(row) }}
    </div>
</ng-template>
<!-- End of Custom table column content -->

<!-- Custom detail content  -->
<ng-template #rule let-row let-item="item">
    <span [class.not-available-text]="!row[item.key]">{{ row[item.key] || "Not available" }}</span>
    <i style="margin-top: 1rem">Source Reference: {{ row.reference || "Not available" }} </i>
</ng-template>
<ng-template #location let-row let-item="item">
    <span [class.not-available-text]="!row[item.key]">{{ row[item.key] || "Not available" }}</span>
    <i style="margin-top: 1rem">Closest Identifier: {{ row.featureIdentifier || "Not available" }} </i>
</ng-template>
<ng-template #schematron let-row let-item="item">
    @if (row.ruleType) {
    <div>{{ row.ruleType }} :</div>
    }
    <span [class.not-available-text]="!row[item.key]">{{ row[item.key] || "Not available" }}</span>
</ng-template>
<!-- End of Custom detail content  -->